import system from './system'
import home from './home'
import app from './app'
import pub from './pub'
import dashboard from './dashboard'
import user from './user'
import company from './company'
import employees from './employees'
import project from './project'
// import worker from './worker'
// import team from './team'
import statistics from './statistics'
// 建协
import member from './member'
import expert from './expert'
import lottery from './lottery'
import area from './area'

// 内容管理
import cms from './cms'
// 业务管理
import business from './business'
// 申报系统
import psm from './psm'
import cert from './cert'

// 参数管理
import param from './param'

// 会务管理
import conference from './conference'
// 班组资信评价管理
import evaluation from './evaluation'
// 百千万工程
import millionsProject from './millionsProject'

export default {
  system,
  home,
  app,
  pub,
  dashboard,
  user,
  company,
  employees,
  project,
  // worker,
  // team,
  statistics,
  member,
  expert,
  lottery,
  area,
  cms,
  psm,
  cert,
  business,
  param,
  conference,
  evaluation,
  millionsProject
}



// WEBPACK FOOTER //
// ./src/api/index.js